import { BreakPoint, BREAKPOINTS } from '@angular/flex-layout';

const customBreakpoints: BreakPoint[] = [
  {
    alias: 'mobile',
    suffix: 'Mobile',
    mediaQuery: 'screen and (max-width: 480px)',
    overlapping: true,
  },
  {
    alias: 'tablet',
    suffix: 'Tablet',
    mediaQuery: 'screen and (min-width: 768px)',
    overlapping: true,
  },
  {
    alias: 'desktop-small',
    suffix: 'DesktopSmall',
    mediaQuery: 'screen and (min-width: 960px)',
    overlapping: true,
  },
  {
    alias: 'desktop-large',
    suffix: 'DesktopLarge',
    mediaQuery: 'screen and (min-width: 1176px)',
    overlapping: true,
  },
  {
    alias: 'desktop-xlarge',
    suffix: 'DesktopXLarge',
    mediaQuery: 'screen and (min-width: 1440px)',
    overlapping: true,
  },
  {
    alias: 'desktop-xxlarge',
    suffix: 'DesktopXXLarge',
    mediaQuery: 'screen and (min-width: 1600px)',
    overlapping: true,
  },
  {
    alias: 'desktop-xxlarge',
    suffix: 'DesktopXXLarge',
    mediaQuery: 'screen and (min-width: 2561px)',
    overlapping: true,
  },
];

export const CustomBreakPointsProviders = {
  provide: BREAKPOINTS,
  useValue: [...customBreakpoints],
};



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/ui/layout/breakpoints.ts